import { QueryClient } from '@tanstack/react-query'
import { createTRPCClient, httpBatchLink } from '@trpc/client'
import type { AppRouter } from './router.server'

export const PERSISTED_QUERY_MAX_AGE = 1000 * 60 * 60 * 24 * 5
const QUERY_STALE_TIME = 60 * 1000
const BROWSER_QUERY_GC_TIME = PERSISTED_QUERY_MAX_AGE
const SERVER_QUERY_GC_TIME = 2 * 1000

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        gcTime:
          typeof window === 'undefined'
            ? SERVER_QUERY_GC_TIME
            : BROWSER_QUERY_GC_TIME,
        staleTime: QUERY_STALE_TIME,
      },
    },
  })
}

function createTRPCBrowserClient() {
  return createTRPCClient<AppRouter>({
    links: [
      httpBatchLink({
        url: '/api/trpc',
      }),
    ],
  })
}

let browserQueryClient: QueryClient | undefined
let browserTRPCClient: ReturnType<typeof createTRPCBrowserClient> | undefined

export function getQueryClient() {
  if (typeof window === 'undefined') {
    return createQueryClient()
  }

  browserQueryClient ??= createQueryClient()

  return browserQueryClient
}

export function getTRPCClient() {
  if (typeof window === 'undefined') {
    return createTRPCBrowserClient()
  }

  browserTRPCClient ??= createTRPCBrowserClient()

  return browserTRPCClient
}
